import { Budget, BudgetSchedule, BudgetSection, LineItem } from "../store/budget.data"

export const calculateLineItemBaseAmount = ({ quantity, unitCost, recurrence }: LineItem, conversionRate: number) =>
  (quantity || 0) * (unitCost || 0) * (recurrence || 1) * conversionRate // standardizing to ensure works same everywhere

export const getConversionRate = (bs: BudgetSection, budgetCurrency: string) => 
  !bs.settings.currency || budgetCurrency === bs.settings.currency ? 1 : bs.settings.conversionRate || 1


export const updateBudgetScheduleInPlace = (bs: BudgetSchedule) => {
  if (!bs) return 
  bs.total = 0
  bs.paid = 0
  bs.pending = 0
  bs.items.forEach(({ amount, status }) => {
    if (!amount) return
    bs.total += amount
    if (status === 'Paid') bs.paid += amount
    else bs.pending += amount
  })
}

export const updateBudgetSectionInPlace = (bs: BudgetSection, budgetCurrency: string, ignoreNonShows = false) => {
  bs.tax = 0
  bs.fees = 0
  bs.discount = 0
  bs.subTotal = 0
  bs.total = 0
  const { useFees, useTax, useDiscount, taxInclusive, taxRate, feeRate, discountRate } = bs.settings
  
  const conversionRate = getConversionRate(bs, budgetCurrency)
  bs.lineItems.forEach(li => {
    const { tax, fees, discount } = li
    const baseAmount = calculateLineItemBaseAmount(li, conversionRate)
    li.total = baseAmount

    if (ignoreNonShows && !li.show) {
      console.log("SHOULD BE IGNORING " + li.description)
      return // this is for the toggle sections (tasks / assets) where a line item is in the section but not really
    }
    const discountAmount = !useDiscount || !discountRate || !discount ? 0 : baseAmount * discountRate 
    
    const feeAmount = !useFees || !feeRate || !fees ? 0 : (baseAmount - discountAmount) * feeRate
    const subtotal = baseAmount - discountAmount + feeAmount
    const taxAmount = !useTax || !tax || !taxRate ? 0 : taxInclusive ?
      subtotal - subtotal * (1/(1 + taxRate)) :
      subtotal * taxRate

    const totalAmount = taxInclusive ? subtotal : (subtotal + taxAmount)

    bs.discount += discountAmount
    bs.fees += feeAmount
    bs.tax += taxAmount
    bs.subTotal += (taxInclusive ? (subtotal - taxAmount) : subtotal)
    bs.total += totalAmount
  })
}

export const updateBudgetInPlace = (budget: Budget) => {
  if (!budget) return

  updateBudgetScheduleInPlace(budget.revenuePaymentSchedule)
  budget.costIds.forEach(id => updateBudgetScheduleInPlace(budget.sections[id].schedule))

  Object.values(budget.sections).forEach(bs => updateBudgetSectionInPlace(bs, budget.currency))

  budget.totalRevenue = 0
  budget.revenueDiscount = 0
  budget.revenueFees = 0
  budget.revenueSubtotal = 0
  budget.revenueTax = 0

  budget.revenueIds.map(id => budget.sections[id]).forEach(section => {
    budget.totalRevenue += section.total || 0
    budget.revenueDiscount += section.discount || 0
    budget.revenueFees += section.fees || 0
    budget.revenueSubtotal += section.subTotal || 0
    budget.revenueTax += section.tax || 0
  })

  budget.totalCosts = 0
  budget.costsDiscount = 0
  budget.costsFees = 0
  budget.costsSubtotal = 0
  budget.costsTax = 0

  budget.costIds.map(id => budget.sections[id]).forEach(section => {
    budget.totalCosts += section.total || 0
    budget.costsDiscount += section.discount || 0
    budget.costsFees += section.fees || 0
    budget.costsSubtotal += section.subTotal || 0
    budget.costsTax += section.tax || 0
  })
}


export const unlinkSectionInPlace = (section: BudgetSection) => {
  delete section.linkId
  delete section.linkedCache
  delete section.isQuote
  delete section.isTasks
  delete section.isAssets
  delete section.linkJustDeleted
  return section
}